<template>
  <!-- Sign Up User Info Checking Popup -->
  <div class="lbil_doctor_info_modal new_user_info_checking">
    <div class="lbil_doctor_info_modal_wrp">
      <div class="lbil_doctor_info_modal_center">
        <div class="lbil_doctor_info_modal">
          <div class="lbil_doctor_info_modal_header">
            <h3 class="text-left">Doctor Info</h3>
            <span class="new_user_info_checking_close"><i class="fa fa-times"
                @click='consultDoctorInfoPopupHideMethod'></i></span>
          </div>
          <div class="lbil_doctor_info_modal_body">
            <div class="new_user_info_checking_body">
              <ul>
                <li>
                  <span class="new_user_info_key">Name</span> :
                  <span class="new_user_info_val">Dr {{ this.consultDoctorInfoPopupData.first_name }}
                    {{ this.consultDoctorInfoPopupData.last_name }}</span>
                </li>
                <!-- <li v-if="this.consultDoctorInfoPopupData.email">
                  <span class="new_user_info_key">Email</span> :
                  <span class="new_user_info_val">{{ this.consultDoctorInfoPopupData.email }}</span>
                </li> -->
                <!-- <li
                  v-if="this.consultDoctorInfoPopupData.profile && this.consultDoctorInfoPopupData.profile.profile.mobile_country_code">
                  <span class="new_user_info_key">Phone No.</span> :
                  <span
                    class="new_user_info_val">{{ this.consultDoctorInfoPopupData.profile.profile.mobile_country_code }}
                    {{ this.consultDoctorInfoPopupData.profile.profile.mobile }}</span>
                </li> -->
                <li>
                  <span class="new_user_info_key">Hospital/Institute/Clinic/Independent </span> :
                  <span class="new_user_info_val">{{ this.consultDoctorInfoPopupData.organization }}</span>
                </li>
                <li>
                  <span class="new_user_info_key">Area of Specialization</span> :
                  <span
                    class="new_user_info_val">{{ this.consultDoctorInfoPopupData.profile.professional_filter_name }}</span>
                </li>
                <li>
                  <span class="new_user_info_key">Country</span> :
                  <span class="new_user_info_val"
                    style="text-transform:capitalize;">{{ getCountryFlag(this.consultDoctorInfoPopupData.profile.country, 'name') }}</span>
                </li>
                <li>
                  <span class="new_user_info_key">City</span> :
                  <span class="new_user_info_val">{{ this.consultDoctorInfoPopupData.profile.city }}</span>
                </li>
                <li>
                  <span class="new_user_info_key">Languages</span> :
                  <span class="new_user_info_val">
                    <label class="value_label">{{ this.consultDoctorInfoPopupData.language }}</label>
                  </span>
                </li>
                <li>
                  <span class="new_user_info_key">Available Slot</span> :
                  <span class="new_user_info_val">
                    <div class="value_label" v-for="(schedule, weekIndex) in this.consultDoctorInfoPopupData.schedule"
                      :key="weekIndex">
                      <div class="schedule_list">
                        <h4 class="pt-0">{{ weekIndex }}</h4>
                        <table>
                          <thead>
                            <tr style="color:#c2bd83;">
                              <th>Day</th>
                              <th class="pl-5 pr-5">Start Time</th>
                              <th>End Time</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(slot, index) in schedule" :key="index" style="color:#c2bd83;">
                              <td>{{ slot.day }}</td>
                              <td class="pl-5 pr-5">{{ slot.start_time }}</td>
                              <td>{{ slot.end_time }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </span>
                </li>
                <li>
                  <span class="new_user_info_key">License Number</span> :
                  <span class="new_user_info_val">
                    <template v-if="this.consultDoctorInfoPopupData.license_country_code">
                      +{{ this.consultDoctorInfoPopupData.license_country_code }}
                      {{ this.consultDoctorInfoPopupData.license_value }}
                    </template>
                  </span>
                </li>
                <li>
                  <span class="new_user_info_key">Registration Portal</span> :
                  <span class="new_user_info_val">{{ this.consultDoctorInfoPopupData.license_portal }}</span>
                </li>
                <li>
                  <span class="new_user_info_key">License/Certificate Document</span> :
                  <span class="new_user_info_val">
                    <template v-if="this.consultDoctorInfoPopupData.license_file">
                      <a :href="this.consultDoctorInfoPopupData.license_file">Click Here</a>
                    </template>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Sign Up User Info Checking Popup -->
</template>

<script>
/*eslint-disable */
import countries from '@/services/country.json'
import { bus } from '@/main';
import toast from '@/services/toast';
export default {
  props: ['consultDoctorInfoPopupData'],
  data() {
    return {
      countryList: []
    }
  },
  mounted() {
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1)
  },
  methods: {
    getCountryFlag: function (countryCode, type) {
      if (countryCode == null) {
        countryCode = ''
      }
      let countryName = countryCode.toLowerCase()
      let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
      if (country && country.length > 0) {
        country = country[0]
        if (type == 'flag') {
          country = `https://567c9b4f06e54c9c9229fe11191a6432.s3.ca-central-1.amazonaws.com/media/shiny/${country.value}.png`
        } else {
          country = country.name
        }
      } else {
        country = ''
      }
      return country;
    },
    consultDoctorInfoPopupHideMethod() {
      document.body.classList.remove('body_right_scroll_remove')
      bus.$emit('consultDoctorInfoPopupStateBus', false);
    },
  },
}
</script>

<style lang="scss" scoped>
.lbil_doctor_info_modal {
  position: fixed;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.92);
  left: 0;
  right: 0;
  z-index: 1000;
  min-height: 100dvh;
  width: 100%;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 8px;
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #333333;
  }

  .lbil_doctor_info_modal {
    background: #000;
    max-width: 720px;
    margin: 0px auto;
    border-radius: 5px;
    padding: 0px 15px;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    color: #ffffff;
    box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
  }

  .lbil_doctor_info_modal_wrp {
    display: table;
    width: 100%;
    height: 100%;
  }

  .lbil_doctor_info_modal_header {
    padding: 10px 0px;
    position: relative;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);

    .new_user_info_checking_close {
      position: absolute;
      top: 15px;
      right: 10px;
      line-height: 1;

      .fa {
        font-size: 24px;
        color: red;
        cursor: pointer;
        transform: scale(1);
        -webkit-transform: scale(1);
        -moz-transform: scale(1);
        -webkit-transition: all ease 0.5s;
        transition: all ease 0.5s;

        &:hover {
          color: #87cefa;
        }
      }
    }
  }

  .lbil_doctor_info_modal_center {
    display: table-cell;
    vertical-align: middle;
  }

  .new_user_info_checking_body li {
    font-size: 20px;
    padding: 15px 20px 0;
    display: flex;

    .new_user_info_key {
      color: #b1b1b1ee;
      display: inline-block;
      margin-right: 15px;
    }

    .new_user_info_val {
      display: inline-block;
      margin-left: 10px;
      color: #ffcd1d;

      .value_label:last-child {
        i {
          display: none;
        }
      }
    }
  }
}
.schedule_list h4 {
    font-size: 18px;
    border-bottom: 1px solid #181818;
    padding: 15px 0;
    text-transform: capitalize;
}
</style>